import { useState } from "react";
import { PractitionerService } from "utils/PractitionerService";
import { Link } from "react-router-dom";
import { useRef } from "react";
import { Button, Card, CardBody, Collapse } from "reactstrap";
import { useEffect } from "react";
import { createImageFromInitials, getRandomColor } from "utils/Utils";
import { encrypt } from "utils/EncryptDecrypt";
import NoConnection from "pages/Connections/components/NoConnection";
import CommonLoader from "common/CommonLoader";
import { useSelector } from "react-redux";

const PeopleKnowWidget = (props) => {
    const [practitioners, setPractitioners] = useState([]);
    const currentUser = useSelector((state) => state.auth.currentUser);
    const [hasMore, setHasMore] = useState(false);
    const currentPage = useRef(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => setIsOpen(!isOpen);

    const fetchData = () => {
        try {
            const pageNo = currentPage.current + 1;
            currentPage.current = pageNo;

            PractitionerService.getPractitionerProfiles(`ps == '*${encodeURIComponent(currentUser?.primarySpeciality)}*'`, pageNo)
                .then((response) => {
                    if (response.status === 200) {
                        const { currentPage, totalPages, contents } = response.data;
                        setPractitioners((prevPractitioners) => [...prevPractitioners, ...contents]);
                        setHasMore(totalPages - currentPage !== 1);
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                });
        } catch (e) {
            if (alert) alert.error(e.message);
        }
    };

    useEffect(() => {
        PractitionerService.getPractitionerProfiles(`ps == '*${encodeURIComponent(currentUser?.primarySpeciality)}*'`, 0)
            .then((response) => {
                if (response.status === 200) {
                    const { currentPage, totalPages, contents } = response.data;
                    setPractitioners(contents);
                    setIsLoading(false);
                    setHasMore(totalPages - currentPage !== 1);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err.message);
            });
    }, [currentUser?.primarySpeciality]);


    return (
        <Card className={`nexogic-widget-sidebar-card job-card bg-white ${isOpen ? 'content-colapse-open' : 'content-colapse-close'}`}>
            <h3 className="nex-aside-title" onClick={toggle}>People you may Know <svg className="icon ml-auto" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 17.25C8.9225 17.2425 8.3525 17.0925 7.85 16.815C7.4975 16.62 7.175 16.3575 6.9125 16.05C6.5 16.0875 6.0875 16.05 5.69 15.93C5.1275 15.7725 4.6175 15.465 4.205 15.0525C3.7925 14.64 3.5 14.13 3.3425 13.575C3.23 13.185 3.185 12.7725 3.215 12.3675C2.9 12.0975 2.6375 11.775 2.435 11.415C2.15 10.9125 2 10.335 2 9.75C2 9.165 2.15 8.5875 2.435 8.0775C2.6375 7.725 2.9 7.4025 3.2075 7.1325C3.1775 6.7275 3.215 6.3225 3.3275 5.9325C3.485 5.3775 3.785 4.8675 4.1825 4.455C4.805 3.8325 5.63 3.4725 6.5075 3.435C6.6425 3.435 6.755 3.435 6.8825 3.45C7.1525 3.135 7.475 2.88 7.835 2.6775C8.3375 2.4 8.915 2.25 9.4925 2.25C9.4925 2.25 9.4925 2.25 9.5 2.25C10.0775 2.25 10.6475 2.4 11.1575 2.6775C11.5175 2.8725 11.84 3.135 12.1025 3.4425C12.515 3.4125 12.9275 3.4575 13.325 3.57C13.88 3.735 14.39 4.035 14.8025 4.44C15.215 4.8525 15.515 5.3625 15.6725 5.9175C15.785 6.315 15.83 6.7275 15.8 7.1325C16.1075 7.4025 16.37 7.725 16.5725 8.085C16.85 8.595 17 9.1725 17 9.75C17 10.3275 16.85 10.8975 16.5725 11.4075C16.3775 11.7675 16.115 12.09 15.8075 12.3525C15.8375 12.765 15.7925 13.1775 15.68 13.575C15.515 14.13 15.215 14.64 14.8025 15.0525C14.39 15.465 13.88 15.765 13.325 15.93C12.9275 16.0425 12.515 16.0875 12.11 16.0575C11.84 16.365 11.5175 16.6275 11.1575 16.83C10.655 17.1 10.0775 17.25 9.5 17.25ZM7.2425 14.4975C7.4975 14.4975 7.7375 14.625 7.8725 14.8425C8.045 15.12 8.2925 15.345 8.57 15.5025C8.8625 15.66 9.185 15.75 9.5075 15.75C9.83 15.75 10.1525 15.6675 10.445 15.51C10.73 15.3525 10.9775 15.12 11.15 14.85C11.3225 14.58 11.6375 14.4525 11.945 14.52C12.2675 14.595 12.5975 14.58 12.9125 14.49C13.2275 14.4 13.5125 14.2275 13.745 13.995C13.9775 13.7625 14.15 13.4775 14.24 13.1625C14.33 12.8475 14.3375 12.51 14.27 12.195C14.2025 11.8875 14.33 11.5725 14.6 11.4C14.8775 11.22 15.1025 10.98 15.26 10.695C15.4175 10.4025 15.5 10.0725 15.5 9.75C15.5 9.42 15.4175 9.0975 15.26 8.8125C15.1025 8.5275 14.87 8.28 14.6 8.1075C14.33 7.935 14.2025 7.62 14.27 7.3125C14.345 6.99 14.33 6.66 14.24 6.345C14.15 6.03 13.9775 5.7375 13.745 5.5125C13.5125 5.28 13.2275 5.1075 12.9125 5.0175C12.5975 4.9275 12.26 4.92 11.945 4.9875C11.6375 5.0625 11.3225 4.9275 11.15 4.6575C10.9775 4.38 10.73 4.155 10.445 3.9975C10.1525 3.8325 9.8225 3.75 9.5 3.75C9.17 3.75 8.84 3.8325 8.555 3.99C8.27 4.1475 8.0225 4.38 7.85 4.6575C7.6775 4.935 7.3475 5.0625 7.0325 4.9875C6.875 4.95 6.71 4.9275 6.5525 4.935C6.0725 4.95 5.6075 5.16 5.255 5.505C5.03 5.73 4.865 6.0225 4.775 6.3375C4.685 6.6525 4.6775 6.9825 4.7525 7.305C4.82 7.6125 4.6925 7.935 4.4225 8.1075C4.1375 8.28 3.905 8.5275 3.7475 8.8125C3.59 9.0975 3.5 9.4275 3.5 9.75C3.5 10.08 3.5825 10.4025 3.7475 10.695C3.905 10.98 4.1375 11.2275 4.415 11.4C4.685 11.5725 4.82 11.8875 4.7525 12.2025C4.6775 12.5175 4.6925 12.855 4.7825 13.17C4.8725 13.485 5.0375 13.77 5.27 14.0025C5.5025 14.2275 5.7875 14.4 6.1025 14.49C6.4175 14.58 6.755 14.5875 7.0775 14.5125C7.13 14.505 7.19 14.4975 7.2425 14.4975Z" fill="black" />
                <path d="M8.75188 11.9983C8.55688 11.9983 8.36938 11.9233 8.21938 11.7808C7.92687 11.4883 7.92687 11.0158 8.21938 10.7233L11.2194 7.72328C11.5119 7.43078 11.9844 7.43078 12.2769 7.72328C12.5694 8.01578 12.5694 8.48828 12.2769 8.78078L9.27688 11.7808C9.13437 11.9233 8.94688 11.9983 8.75188 11.9983Z" fill="black" />
                <path d="M8.75187 11.9983C8.55687 11.9983 8.36937 11.9233 8.21938 11.7808L6.71937 10.2808C6.42688 9.98828 6.42688 9.51578 6.71937 9.22328C7.01187 8.93078 7.48437 8.93078 7.77687 9.22328L9.27688 10.7233C9.56937 11.0158 9.56937 11.4883 9.27688 11.7808C9.13437 11.9233 8.94688 11.9983 8.75187 11.9983Z" fill="black" />
            </svg>
            </h3>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    {isLoading ?
                        <div className="text-center">
                            <CommonLoader />
                        </div>
                        :
                        <>
                            <div className="nexogic-custom-scroll" style={{ height: "500px", overflow: "auto" }}>
                                <div className="card-group nexogic-card-group-list has-shadow">
                                    {practitioners.map((item, index) => (
                                        <div className="card" key={`job_list${index} `}>
                                            <div className="row no-gutters align-items-start">
                                                {
                                                    <div className="col-auto icon">
                                                        <Link to={`/profile/${item?.profileId}`}>
                                                            {item && item.avatarId ? (
                                                                <img
                                                                    src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${item?.profileGuid}/${item?.avatarId}`}
                                                                    className="card-img"
                                                                    alt="#"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src={createImageFromInitials(
                                                                        50,
                                                                        `${item?.name.replace("Dr. ", "")}`,
                                                                        getRandomColor(encrypt(item?.profileGuid).toString())
                                                                    )}
                                                                    className="card-img"
                                                                    alt="#"
                                                                />
                                                            )}
                                                        </Link>
                                                    </div>
                                                }
                                                <div className="col">
                                                    <h4 className="card-title text-clamp">
                                                        {item?.name && (
                                                            <Link to={`/profile/${item?.profileId}`}>
                                                                {item?.name}
                                                                {", "}
                                                                {item?.qualification}
                                                            </Link>
                                                        )}
                                                    </h4>
                                                    <p className="card-text">
                                                        {item?.primarySpeciality && (
                                                            <small className="text-muted">
                                                                {item?.primarySpeciality}
                                                            </small>
                                                        )}
                                                    </p>
                                                    {/** 
                                                    <p className="card-text">
                                                        <small className="text-muted"><img src={marker_icon} alt="#" /> {item?.location}{" "}
                                                            {item?.city}</small>
                                                    </p>
                                                    */}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {practitioners.length === 0 && <NoConnection content={"No Candidate"} />}
                                    
                                </div>
                            </div>

                            {practitioners.length > 0 && hasMore && (
                                <div className="mt-2">
                                    <Button color="link" className="readmore nex-btn-primary text-white" onClick={fetchData}>
                                        View More
                                    </Button>
                                </div>
                            )}
                        </>
                    }
                </CardBody>
            </Collapse>
        </Card>
    )
}

export default PeopleKnowWidget;